import { actions } from './actions'

const initialState = {
  traduccionesPagina: {
    data: [],
    loading: false,
    error: '',
  },
  traduccionPagina: {
    data: null,
    loading: false,
    error: '',
  },
}

export default function traduccionesPaginaReducer(state = initialState, action) {
  switch (action.type) {
    case actions.TRADUCCIONES_PAGINA_LOAD_REQUESTED:
      return { ...state, traduccionesPagina: { ...state.traduccionesPagina, loading: true } }
    case actions.TRADUCCIONES_PAGINA_LOAD_SUCCEEDED:
      return {
        ...state,
        traduccionesPagina: { ...state.traduccionesPagina, data: action.payload, loading: false },
      }
    case actions.TRADUCCIONES_PAGINA_LOAD_FILED:
      return {
        ...state,
        traduccionesPagina: { ...state.traduccionesPagina, loading: false, error: action.error },
      }
    case actions.TRADUCCION_PAGINA_UPDATE_REQUESTED:
      return {
        ...state,
        traduccionPagina: { ...state.traduccionPagina, loading: true, error: '' },
      }
    case actions.TRADUCCION_PAGINA_UPDATE_SUCCEEDED:
      return {
        ...state,
        traduccionPagina: {
          ...state.traduccionPagina,
          data: action.payload,
          loading: false,
          error: '',
        },
      }
    case actions.TRADUCCION_PAGINA_UPDATE_FILED:
      return {
        ...state,
        traduccionPagina: { ...state.traduccionPagina, loading: false, error: action.error },
      }
    case actions.TRADUCCION_PAGINA_INSERT_REQUESTED:
      return {
        ...state,
        traduccionPagina: { ...state.traduccionPagina, loading: true, error: '' },
      }
    case actions.TRADUCCION_PAGINA_INSERT_SUCCEEDED:
      return {
        ...state,
        traduccionesPagina: {
          ...state.traduccionPagina,
          data: [].concat(action.payload, state.traduccionPagina.data),
          loading: false,
          error: '',
        },
      }
    case actions.TRADUCCION_PAGINA_INSERT_FILED:
      return {
        ...state,
        traduccionPagina: { ...state.traduccionPagina, loading: false, error: action.error },
      }
    case actions.TRADUCCION_PAGINA_DELETE_REQUESTED:
      return {
        ...state,
        traduccionesPagina: { ...state.traduccionesPagina, loading: true, error: '' },
      }
    case actions.TRADUCCION_PAGINA_DELETE_SUCCEEDED:
      return {
        ...state,
        traduccionesPagina: {
          ...state.traduccionesPagina,
          data: state.traduccionesPagina.data.filter(trad => trad.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.TRADUCCION_PAGINA_DELETE_FILED:
      return {
        ...state,
        traduccionesPagina: { ...state.traduccionesPagina, loading: false, error: action.error },
      }
    case actions.TRADUCCION_PAGINA_BY_TIPO_ID_LOAD_REQUESTED:
      return {
        ...state,
        traduccionPagina: { ...state.traduccionPagina, data: null, loading: true },
      }
    case actions.TRADUCCION_PAGINA_BY_TIPO_ID_LOAD_SUCCEEDED:
      return {
        ...state,
        traduccionPagina: { ...state.traduccionPagina, data: action.payload, loading: false },
      }
    case actions.TRADUCCION_PAGINA_BY_TIPO_ID_LOAD_FILED:
      return {
        ...state,
        traduccionPagina: { ...state.traduccionPagina, loading: false, error: action.error },
      }
    case actions.TRADUCCION_PAGINA_BY_TIPO_ID_LOAD_INSERT_REQUESTED:
      return {
        ...state,
        traduccionPagina: {
          ...state.traduccionPagina,
          data: null,
          loading: false,
          error: action.error,
        },
      }
    default:
      return state
  }
}
